export const WalletIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <path
      d="M4 6h13a2 2 0 0 1 2 2v1h1.5a1.5 1.5 0 0 1 1.5 1.5v3A1.5 1.5 0 0 1 20.5 15H19v1a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2zm0 2v8h13v-1h-1.5A2.5 2.5 0 0 1 13 14.5v-3A2.5 2.5 0 0 1 15.5 9H17V8H4zm11.5 3a.5.5 0 0 0-.5.5v3c0 .28.22.5.5.5h5v-4h-5zm.5 1.5h2v1h-2v-1z"
      fill="#cfd1dc"
    />
  </svg>
);
